import React from 'react';

import { AvatarProps } from './Avatar';

export const withDefaultAvatar =
  (AvatarComponent: React.ComponentType<AvatarProps>, defaultAvatar: string) =>
  ({ ...props }: AvatarProps) => <AvatarComponent {...props} src={props.src || defaultAvatar} />;
